export default class SI {

	public static adversaries: Adversary[] = [
		{
			name: 'Brandenburg-Prussia',
			difficulty: [1, 2, 4, 6, 7, 9, 10],
		},
		{
			name: 'England',
			difficulty: [1, 3, 4, 6, 7, 9, 11],
		},
		{
			name: 'France',
			difficulty: [2, 3, 5, 7, 8, 9, 10],
		},
		{
			name: 'Habsburg (Livestock)',
			difficulty: [2, 3, 5, 6, 8, 9, 10],
		},
		{
			name: 'Habsburg (Mining)',
			difficulty: [1, 3, 4, 5, 7, 9, 10],
		},
		{
			name: 'Russia',
			difficulty: [1, 3, 4, 6, 7, 9, 11],
		},
		{
			name: 'Scotland',
			difficulty: [1, 3, 4, 6, 7, 8, 10],
		},
		{
			name: 'Sweden',
			difficulty: [1, 2, 3, 5, 6, 7, 8],
		},
	]

	public static adversaryLossConditions = [
		`Loss to England's Additional Loss Condition`,
		`Loss to England's Loss Condition`,
		`Loss to England's special rule`,
		`Loss to France's Additional Loss Condition`,
		`Loss to France's Loss Condition`,
		`Loss to France's special rule`,
		`Loss to Habsburg's Additional Loss Condition`,
		`Loss to Habsburg's Loss Condition`,
		`Loss to Habsburg's special rule`,
		`Loss to Russia's Additional Loss Condition`,
		`Loss to Russia's Loss Condition`,
		`Loss to Russia's special rule`,
		`Loss to Scotland's Additional Loss Condition`,
		`Loss to Scotland's Loss Condition`,
		`Loss to Scotland's special rule`,
	]

	public static blightCards = [
		'A Pall Upon The Land',
		'Aid From Lesser Spirits',
		'All Things Weaken',
		'Attenuated Essence',
		'Back Against The Wall',
		'Blight Corrodes The Spirit',
		'Burn Brightest Before The End',
		'Disintegrating Ecosystem',
		'Downward Spiral',
		'Erosion Of Will',
		'Intensifying Exploitation',
		'Memory Fades To Dust',
		'Power Corrodes The Spirit',
		'Promising Farmlands',
		'Shattered Fragments Of Power',
		'Slow Dissolution Of Will',
		'Thriving Communities',
		'Tipping Point',
		'Unnatural Proliferation',
		'Untended Land Crumbles',
	]

	public static blightLosses = ['Blight Loss', 'Loss to Blight', 'Lost by Blight', 'Lost to Blight', 'Overwhelmed by Blight', 'Too much Blight']

	public static healthyIslands = [
		`Blight card never flipped`,
		`Blight card didn't flip`,
	]

	public static scenarios = [
		`A Diversity of Spirits`,
		`Blitz`,
		`Dahan Insurrection`,
		`Despicable Theft`,
		`Elemental Invocation`,
		`Guard The Isle's Heart`,
		`Rituals Of Terror`,
		`Rituals Of The Destroying Flame`,
		`Powers Long Forgotten`,
		`The Great River`,
		`Varied Terrains`,
		`Ward The Shores`,
	]

	public static separator = '／' // The weird slash-like character that BGStats uses

	public static expansionClass: Map<Expansion, string> = new Map([
		['Base', 'base'],
		['Branch And Claw', 'branch-and-claw'],
		['Promo Pack 1', 'promo-pack-1'],
		['Jagged Earth', 'jagged-earth'],
		['Promo Pack 2', 'promo-pack-2'],
		['Horizons', 'horizons'],
		['Nature Incarnate', 'nature-incarnate'],
		['Apocrypha', 'apocrypha'],
	])

	public static expansionOrder: Map<Expansion, number> = new Map([
		['Base', 1],
		['Branch And Claw', 2],
		['Promo Pack 1', 3],
		['Jagged Earth', 4],
		['Promo Pack 2', 5],
		['Horizons', 6],
		['Nature Incarnate', 7],
		['Apocrypha', 8],
	])

	public static spirits: Spirit[] = [
		{ name: `Ember-Eyed Behemoth`, nickname: `Behemoth`, expansion: 'Nature Incarnate' },
		{ name: `Bringer Of Dreams And Nightmares`, nickname: `Bringer`, expansion: 'Base' },
		{ name: `Covets Gleaming Shards of Earth`, nickname: `Covets`, expansion: 'Apocrypha' },
		{ name: `Breath Of Darkness Down Your Spine`, nickname: `Darkness`, expansion: 'Nature Incarnate' },
		{ name: `Downpour Drenches The World`, nickname: `Downpour`, expansion: 'Promo Pack 2' },
		{ name: `Vital Strength Of The Earth`, nickname: `Earth`, expansion: 'Base' },
		{ name: `Dances Up Earthquakes`, nickname: `Earthquakes`, expansion: 'Nature Incarnate' },
		{ name: `Eyes Watch From The Trees`, nickname: `Eyes`, expansion: 'Horizons' },
		{ name: `Sharp Fangs Behind The Leaves`, nickname: `Fangs`, expansion: 'Branch And Claw' },
		{ name: `Finder Of Paths Unseen`, nickname: `Finder`, expansion: 'Promo Pack 2' },
		{ name: `Fractured Days Split The Sky`, nickname: `Fractured Days`, expansion: 'Jagged Earth' },
		{ name: `Relentless Gaze Of The Sun`, nickname: `Gaze`, expansion: 'Nature Incarnate' },
		{ name: `A Spread Of Rampant Green`, nickname: `Green`, expansion: 'Base' },
		{ name: `Hearth-Vigil`, nickname: `Hearth-Vigil`, expansion: 'Nature Incarnate' },
		{ name: `Rising Heat Of Stone And Sand`, nickname: `Heat`, expansion: 'Horizons' },
		{ name: `Keeper Of The Forbidden Wilds`, nickname: `Keeper`, expansion: 'Branch And Claw' },
		{ name: `Lightning's Swift Strike`, nickname: `Lightning`, expansion: 'Base' },
		{ name: `Lure Of The Deep Wilderness`, nickname: `Lure`, expansion: 'Jagged Earth' },
		{ name: `Many Minds Move As One`, nickname: `Many Minds`, expansion: 'Jagged Earth' },
		{ name: `Shifting Memory Of Ages`, nickname: `Memory`, expansion: 'Jagged Earth' },
		{ name: `Shroud Of Silent Mist`, nickname: `Mist`, expansion: 'Jagged Earth' },
		{ name: `Fathomless Mud Of The Swamp`, nickname: `Mud`, expansion: 'Horizons' },
		{ name: `Ocean's Hungry Grasp`, nickname: `Ocean`, expansion: 'Base' },
		{ name: `River Surges In Sunlight`, nickname: `River`, expansion: 'Base' },
		{ name: `Towering Roots Of The Jungle`, nickname: `Roots`, expansion: 'Nature Incarnate' },
		{ name: `Spreading Rot Renews The Earth`, nickname: `Rot`, expansion: 'Apocrypha' },
		{ name: `Serpent Slumbering Beneath The Island`, nickname: `Serpent`, expansion: 'Promo Pack 1' },
		{ name: `Shadows Flicker Like Flame`, nickname: `Shadows`, expansion: 'Base' },
		{ name: `Starlight Seeks Its Form`, nickname: `Starlight`, expansion: 'Jagged Earth' },
		{ name: `Stone's Unyielding Defiance`, nickname: `Stone`, expansion: 'Jagged Earth' },
		{ name: `Devouring Teeth Lurk Underfoot`, nickname: `Teeth`, expansion: 'Horizons' },
		{ name: `Thunderspeaker`, nickname: `Thunderspeaker`, expansion: 'Base' },
		{ name: `Grinning Trickster Stirs Up Trouble`, nickname: `Trickster`, expansion: 'Jagged Earth' },
		{ name: `Vengeance As A Burning Plague`, nickname: `Vengeance`, expansion: 'Jagged Earth' },
		{ name: `Wandering Voice Keens Delirium`, nickname: `Voice`, expansion: 'Nature Incarnate' },
		{ name: `Wounded Waters Bleeding`, nickname: `Waters`, expansion: 'Nature Incarnate' },
		{ name: `Volcano Looming High`, nickname: `Volcano`, expansion: 'Jagged Earth' },
		{ name: `Sun-Bright Whirlwind`, nickname: `Whirlwind`, expansion: 'Horizons' },
		{ name: `Heart Of The Wildfire`, nickname: `Wildfire`, expansion: 'Promo Pack 1' },
	]

	public static aspects: Aspect[] = [
		{ spirit: this.spirits.find(s => s.name === `A Spread Of Rampant Green`)!, name: `Regrowth`, },
		{ spirit: this.spirits.find(s => s.name === `A Spread Of Rampant Green`)!, name: `Tangles`, },
		{ spirit: this.spirits.find(s => s.name === `Bringer Of Dreams And Nightmares`)!, name: `Enticing`, },
		{ spirit: this.spirits.find(s => s.name === `Bringer Of Dreams And Nightmares`)!, name: `Violence`, },
		{ spirit: this.spirits.find(s => s.name === `Heart Of The Wildfire`)!, name: `Transforming`, },
		{ spirit: this.spirits.find(s => s.name === `Keeper Of The Forbidden Wilds`)!, name: `Spreading Hostility`, },
		{ spirit: this.spirits.find(s => s.name === `Lightning's Swift Strike`)!, name: `Immense`, },
		{ spirit: this.spirits.find(s => s.name === `Lightning's Swift Strike`)!, name: `Pandemonium`, },
		{ spirit: this.spirits.find(s => s.name === `Lightning's Swift Strike`)!, name: `Sparking`, },
		{ spirit: this.spirits.find(s => s.name === `Lightning's Swift Strike`)!, name: `Wind`, },
		{ spirit: this.spirits.find(s => s.name === `Lure Of The Deep Wilderness`)!, name: `Lair`, },
		{ spirit: this.spirits.find(s => s.name === `Ocean's Hungry Grasp`)!, name: `Deeps`, },
		{ spirit: this.spirits.find(s => s.name === `River Surges In Sunlight`)!, name: `Haven`, },
		{ spirit: this.spirits.find(s => s.name === `River Surges In Sunlight`)!, name: `Sunshine`, },
		{ spirit: this.spirits.find(s => s.name === `River Surges In Sunlight`)!, name: `Travel`, },
		{ spirit: this.spirits.find(s => s.name === `Serpent Slumbering Beneath The Island`)!, name: `Locus`, },
		{ spirit: this.spirits.find(s => s.name === `Shadows Flicker Like Flame`)!, name: `Amorphous`, },
		{ spirit: this.spirits.find(s => s.name === `Shadows Flicker Like Flame`)!, name: `Dark Fire`, },
		{ spirit: this.spirits.find(s => s.name === `Shadows Flicker Like Flame`)!, name: `Foreboding`, },
		{ spirit: this.spirits.find(s => s.name === `Shadows Flicker Like Flame`)!, name: `Madness`, },
		{ spirit: this.spirits.find(s => s.name === `Shadows Flicker Like Flame`)!, name: `Reach`, },
		{ spirit: this.spirits.find(s => s.name === `Sharp Fangs Behind The Leaves`)!, name: `Encircle`, },
		{ spirit: this.spirits.find(s => s.name === `Sharp Fangs Behind The Leaves`)!, name: `Unconstrained`, },
		{ spirit: this.spirits.find(s => s.name === `Shifting Memory Of Ages`)!, name: `Intensify`, },
		{ spirit: this.spirits.find(s => s.name === `Shifting Memory Of Ages`)!, name: `Mentor`, },
		{ spirit: this.spirits.find(s => s.name === `Shroud Of Silent Mist`)!, name: `Stranded`, },
		{ spirit: this.spirits.find(s => s.name === `Thunderspeaker`)!, name: `Tactician`, },
		{ spirit: this.spirits.find(s => s.name === `Thunderspeaker`)!, name: `Warrior`, },
		{ spirit: this.spirits.find(s => s.name === `Vital Strength Of The Earth`)!, name: `Might`, },
		{ spirit: this.spirits.find(s => s.name === `Vital Strength Of The Earth`)!, name: `Nourishing`, },
		{ spirit: this.spirits.find(s => s.name === `Vital Strength Of The Earth`)!, name: `Resilience`, },
	]

	public static spiritDestroyedLossConditions = [
		`Loss by Spirit Destroyed`,
		`Loss due to Destroyed Spirit`,
		`Loss due to Spirit Destroyed`,
		`Loss from Destroyed Spirit`,
		`Loss from Spirit Destroyed`,
		`Spirit Destroyed`,
	]

	public static stillHealthyCards = [
		'Invaders Find The Land To Their Liking',
		'Strong Earth Shatters Slowly',
		'The Border Of Life And Death',
		"Thriving Crops",
	]

	public static timeOutLosses = ['Loss to time', 'Lost to time', 'Out of time', 'Ran out of Invader cards', 'Ran out of time', 'Timed out']

	public static maxAdversaryLevel = 6

	public static isSingleAdversaryNoScenario = (play: Play) => {
		return play.adversaries && play.adversaries.length === 1 && !play.scenario && play.additionalBoards === 0 && play.layout !== 'Thematic'
	}
}

export type Expansion =
	'Base'
	| 'Branch And Claw'
	| 'Promo Pack 1'
	| 'Jagged Earth'
	| 'Promo Pack 2'
	| 'Horizons'
	| 'Nature Incarnate'
	| 'Apocrypha'

export interface Adversary {
	difficulty: number[]
	name: string
}

export interface AdversaryLevel {
	level: number
	name: string
}

export interface Aspect {
	spirit: Spirit,
	name: string,
}

export interface IslandState {
	blightCards: string[]
	healthy: boolean
}

export interface Outcome {
	type: string
	victory: boolean
}

export interface Play {
	additionalBoards: number
	adversaries: AdversaryLevel[]
	comments: string
	dateTimeString: string
	difficulty: number | null
	durationMins: number | null
	islandState: IslandState | null
	layout: string
	location: string
	number: number
	outcome: Outcome
	players: Player[]
	scenario: string | null
	score: number | null
	spirits: PlayedSpirit[]
	turns: number | null
}

export interface Player {
	name: string
	playCount: number
}

export interface Spirit {
	name: string
	nickname: string
	expansion: Expansion
}

export interface PlayedSpirit {
	aspect: string | null
	player: Player
	spirit: Spirit
}
